import { UniDriver, UniDriverList } from '@wix/unidriver-core';
import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { DATA_HOOKS } from './constants';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface CarouselWIPUniDriver extends BaseUniDriver {
  isLoading: () => Promise<boolean>;
  children: UniDriverList;
  /** @deprecated use children */
  getChildren: () => Promise<UniDriver[]>;
  getImages: () => Promise<Array<string | null>>;
  clickPrevious: () => Promise<void>;
  clickNext: () => Promise<void>;
}

export const carouselWIPUniDriverFactory = (
  base: UniDriver,
): CarouselWIPUniDriver => {
  return {
    ...baseUniDriverFactory(base),

    isLoading: async (): Promise<boolean> =>
      (await base.$$(`[data-hook="${DATA_HOOKS.loader}"]`).count()) > 0,

    children: base.$$(`[data-hook="${DATA_HOOKS.child}"]`),

    getChildren: (): Promise<UniDriver[]> =>
      base
        .$$(`[data-hook="${DATA_HOOKS.child}"]`)
        .map(child => Promise.resolve(child)),

    getImages: (): Promise<Array<string | null>> =>
      base
        .$$(`[data-hook="${DATA_HOOKS.carouselImage}"]`)
        .map((img: UniDriver) => img.attr('src')),

    clickPrevious: (): Promise<void> =>
      base.$(`[data-hook="${DATA_HOOKS.prevButton}"]`).click(),

    clickNext: (): Promise<void> =>
      base.$(`[data-hook="${DATA_HOOKS.nextButton}"]`).click(),
  };
};
